export function sustainabilitySlider() {
    let $parent = $(".sustainability-section");
    let $sliderConntainer = $parent.find(".sustainability-slider");
    let $sliderConntainerNav = $parent.find(".nav-list");
    let slideLength = $parent.find(".sustainability-item").length;
    let flag = true;

    $sliderConntainer.slick({
        slidesToShow: 1.21,
        slidesToScroll: 1,
        // autoplay: true,
        // autoplaySpeed: 5000,
        speed: 500,
        arrows: false,
        dots: false,
        infinite: false,
        asNavFor: $sliderConntainerNav,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.04
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1.19
                }
            },
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 1.195
                }
            },
            {
                breakpoint: 1800,
                settings: {
                    slidesToShow: 1.21
                }
            },
        ],
    });

    $sliderConntainerNav.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        arrows: false,
        dots: false,
        focusOnSelect: true,
        infinite: true,
        asNavFor: $sliderConntainer,
        draggable: false,
        swipe: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
    }).on("afterChange", function (event, slick, currentSlide) {
        if (slideLength - 1 === currentSlide) {
            setTimeout(() => {
                $sliderConntainerNav.slick("slickGoTo", 0);
            }, 4500);
        }
    });

    if (slideLength > 1) {
        $sliderConntainer.addClass("show-draggable-icon");
    }

    $(window).on("scroll", function () {

        if ($parent.hasClass("animated") && flag) {
            flag = false;
            $sliderConntainerNav.slick("slickGoTo", 0);
        }
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/sustainabilitySlider.js